module.exports = __webpack_public_path__ + "static/media/cartecadeau.dcb9fdd4.webp";